import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["checkbox", "selectAllCheckbox"];
  }

  updateSelectAll({ target: { dataset: { column } } }) {
    if (this._allCheckboxesChecked(column)) {
      this._selectSelectAllCheckbox(column);
    } else {
      this._unselectSelectAllCheckbox(column);
    }
  }

  onSelectAll(event) {
    const column = event.target.dataset.column;
    const selectAllCheckbox = this._selectAllCheckbox(column);

    if (selectAllCheckbox.checked) {
      this._selectAllCheckboxes(column);
    } else {
      this._unSelectAllCheckboxes(column);
    }
  }

  _selectSelectAllCheckbox(column) {
    const selectAllCheckbox = this._selectAllCheckbox(column);

    selectAllCheckbox.checked = true;
  }

  _unselectSelectAllCheckbox(column) {
    const selectAllCheckbox = this._selectAllCheckbox(column);

    selectAllCheckbox.checked = false;
  }

  _selectAllCheckboxes(column) {
    const checkboxes = this._enabledCheckboxes(column);

    checkboxes.forEach(checkbox => checkbox.checked = true);
  }

  _unSelectAllCheckboxes(column) {
    const checkboxes = this._enabledCheckboxes(column);

    checkboxes.forEach(checkbox => checkbox.checked = false);
  }

  _selectAllCheckbox(column) {
    return this.selectAllCheckboxTargets.find((checkbox) => checkbox.dataset.column === column);
  }

  _enabledCheckboxes(column) {
    return this.checkboxTargets.filter((checkbox) => !checkbox.disabled && checkbox.dataset.column === column);
  }

  _allCheckboxesChecked(column) {
    const enabledCheckboxes = this._enabledCheckboxes(column);

    return enabledCheckboxes.length > 0 && enabledCheckboxes.every((checkbox) => checkbox.checked);
  }
}
